module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projecten")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Projecten")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.projects), function(p, id) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), (p.category) ? _c('td', [_vm._v(_vm._s(p.category))]) : (p.categories) ? _c('td', _vm._l((p.categories), function(c) {
      return _c('span', [_vm._v(_vm._s(c) + " - ")])
    })) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'ProjectEdit',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "uk-link",
      attrs: {
        "uk-icon": "icon: trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(id)
        }
      }
    })])])
  }))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.name),
      expression: "newProject.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Projectnaam"
    },
    domProps: {
      "value": (_vm.newProject.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.title),
      expression: "newProject.title"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Titel"
    },
    domProps: {
      "value": (_vm.newProject.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.link.url),
      expression: "newProject.link.url"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Link"
    },
    domProps: {
      "value": (_vm.newProject.link.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject.link, "url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.link.text),
      expression: "newProject.link.text"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Link Text"
    },
    domProps: {
      "value": (_vm.newProject.link.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject.link, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProject.color),
      expression: "newProject.color"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Project Kleur (hex)"
    },
    domProps: {
      "value": (_vm.newProject.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProject, "color", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCategory),
      expression: "newCategory"
    }],
    staticClass: "uk-select uk-form-width-medium",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.categories), function(c, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(c))])
  })), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addCategory($event)
      }
    }
  }, [_vm._v("toevoegen")])]), _vm._v(" "), (Object.keys(this.newProject.categories).length > 0) ? _c('div', {
    staticClass: "uk-margin"
  }, _vm._l((this.newProject.categories), function(c, key) {
    return _c('div', {
      staticClass: "uk-column-span"
    }, [_c('p', {
      staticClass: "uk-align-left"
    }, [_vm._v(_vm._s(c))]), _vm._v(" "), _c('button', {
      staticClass: "uk-align-right uk-label uk-label-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeCategory(key)
        }
      }
    }, [_c('span', {
      attrs: {
        "uk-icon": "trash"
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('image-picker', {
    on: {
      "choose": _vm.choose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('vue-image', {
    attrs: {
      "img": _vm.newProject.gallery
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("Toevoegen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#page-modal",
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Categorie")]), _vm._v(" "), _c('th', [_vm._v("Laatste update")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt; ratio: 1.2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Project maken")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef2f6638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CUSTOM/custom-modules/PROJECTS/Projects.vue
// module id = 528
// module chunks = 1